import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';

import usePointerPosition from 'hooks/usePointerPosition';

import * as S from './SnapToCursor.styles';

export interface SnapToCursorProps {
  children: React.ReactNode;
  snap?: React.ReactNode;
  overlay?: boolean;
}

const SnapToCursor: React.FunctionComponent<SnapToCursorProps> = ({
  children,
  snap,
  overlay,
}) => {
  const [hovered, setHovered] = useState(false);
  const { onMouseMove, x, y } = usePointerPosition();

  return (
    <S.SnapToCursorWrapper
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onMouseMove={onMouseMove}
    >
      {hovered && (
        <AnimatePresence mode="wait">
          <S.HoverElement style={{ x, y }} overlay={overlay}>
            {snap}
          </S.HoverElement>
        </AnimatePresence>
      )}

      {children}
    </S.SnapToCursorWrapper>
  );
};

export default SnapToCursor;
